var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "h3",
            { staticClass: "m-subheader__title m-subheader__title--separator" },
            [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm._f("titleize")(
                      _vm._f("translate")("system_administration")
                    )
                  ) +
                  "\n          "
              )
            ]
          ),
          _vm._v(" "),
          _c("ul", {
            staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "m-content", attrs: { id: "content" } },
      [
        _c("div", { staticClass: "m-portlet m-portlet--mobile" }, [
          _c("div", { staticClass: "m-portlet__head" }, [
            _c("div", { staticClass: "m-portlet__head-caption" }, [
              _c("div", { staticClass: "m-portlet__head-title" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("h3", { staticClass: "m-portlet__head-text" }, [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("capitalize")(_vm._f("translate")("phrases"))
                      ) +
                      "\n              "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "m-portlet__head-tools" }, [
              _c("ul", { staticClass: "m-portlet__nav" }, [
                _c("li", { staticClass: "m-portlet__nav-item" }, [
                  _vm.validPermission("create", "phrase")
                    ? _c(
                        "a",
                        {
                          staticClass: "btn btn-success m-btn m-btn--icon",
                          attrs: {
                            href: "#",
                            "data-toggle": "modal",
                            "data-backdrop": "static",
                            "data-keyboard": "false",
                            "data-target": "#phrases_modal"
                          },
                          on: {
                            click: function($event) {
                              return _vm.changeModalPhraseStatus(true)
                            }
                          }
                        },
                        [
                          _c("span", [
                            _c("i", { staticClass: "fa fa-plus" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                "\n                      " +
                                  _vm._s(
                                    _vm._f("capitalize")(
                                      _vm._f("translate")("create_phrases")
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "m-portlet__body" },
            [
              _c("s-datatable", {
                attrs: { config: _vm.datatable },
                scopedSlots: _vm._u([
                  {
                    key: "actions",
                    fn: function(props) {
                      return _c("div", {}, [
                        _vm.validPermission("modify", "phrase")
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_edit",
                                attrs: {
                                  "data-toggle": "modal",
                                  "data-backdrop": "static",
                                  "data-keyboard": "false",
                                  "data-target": "#phrases_modal"
                                },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.modifyPhrase(props.row)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "la la-edit" })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.validPermission("delete", "phrase")
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "m-portlet__nav-link btn m-btn m-btn--icon m-btn--icon-only m-btn--pill btn_delete",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removePhrase(props.row.key)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "la la-trash" })]
                            )
                          : _vm._e()
                      ])
                    }
                  }
                ])
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c(
          "s-modal",
          {
            attrs: {
              id: "phrases_modal",
              title: _vm._f("capitalize")(_vm._f("translate")("create_phrases"))
            }
          },
          [
            _c("s-new-phrase", {
              attrs: { slot: "body", data: _vm.phrase },
              slot: "body"
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon" }, [
      _c("i", { staticClass: "flaticon-suitcase" })
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3aea9b00", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3aea9b00","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/languages/phrases/All.vue
// module id = 712
// module chunks = 0 1 63